export default "__VITE_ASSET__CRChD3WY__"